import { Flex } from "@chakra-ui/react";
import { format } from "date-fns";
import { useCallback, useContext, useState } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import { useParams } from "react-router-dom";

import { AbtestReportOrderInput } from "~/src/__generated__/schema";
import { ABTestDefaultReportContainer_Query } from "~/src/__relay_artifacts__/ABTestDefaultReportContainer_Query.graphql";
import { DateRangeContext } from "~/src/components/features/global/HeaderNavigation/DateRangeField";
import { useABTestReportFilterCache } from "~/src/lib/hooks";

import {
  ABTestDefaultReport,
  ABTestDefaultReportFilterButton,
  ABTestReportFilterFormValues as FormValues,
} from "./presentations";

const query = graphql`
  query ABTestDefaultReportContainer_Query(
    $kind: AbtestReportKindInput!
    $filter: AbtestReportFilterInput!
    $order: AbtestReportOrderInput
    $slug: String!
  ) {
    site(slug: $slug) {
      ...ABTestDefaultReport_site
      abtestScenarioPageGroups {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  }
`;

export const ABTestDefaultReportContainer = () => {
  const { siteSlug = "" } = useParams();

  const [sort, setSort] = useState<AbtestReportOrderInput>({
    value: "UNIQUE_USER",
    isDesc: false,
  });

  const initialFilterValues: FormValues = {
    sourceId: null,
    device: null,
    funnelIds: [],
    abtestScenarioPageIds: [],
    pageKind: null,
    abtestScenarioPageTitles: [],
  };

  const { filterValues, setFilterValues } = useABTestReportFilterCache({
    cacheKey: `ABTestDefaultReport_${siteSlug}`,
    initialFilterValues,
  });

  const {
    dateRange: [startOn, endOn],
  } = useContext(DateRangeContext);

  const handleSortClick = useCallback((params: any) => {
    setSort({
      value: params.field,
      isDesc: params.direction === "DESC" ? true : false,
    });
  }, []);

  const { site } = useLazyLoadQuery<ABTestDefaultReportContainer_Query>(query, {
    kind: {
      value: "ABTEST_ID",
      isDateExist: false,
    },
    filter: {
      startDate: format(startOn, "yyyy-MM-dd"),
      endDate: format(endOn, "yyyy-MM-dd"),
      source: filterValues.sourceId,
      device: filterValues.device,
      funnelIds: filterValues.funnelIds,
      abtestScenarioPageIds: filterValues.abtestScenarioPageIds,
    },
    order: sort,
    slug: siteSlug,
  });

  return (
    <>
      <Flex justifyContent={"end"}>
        <ABTestDefaultReportFilterButton
          filterValues={filterValues}
          onSubmit={setFilterValues}
        />
      </Flex>
      <ABTestDefaultReport siteRef={site} onSortClick={handleSortClick} />
    </>
  );
};
